import { OutgoingMembershipProductDto } from 'api/dtos/memberships/products';

const isProductActive = (product: OutgoingMembershipProductDto) =>
  product.product.isActive &&
  (!product.product.startDate ||
    new Date(product.product.startDate) <= new Date()) &&
  (!product.product.endDate || new Date(product.product.endDate) >= new Date());

/**
 * Checks if a tier is disabled based on various conditions.
 */
export const isProductDisabled = (product: OutgoingMembershipProductDto) =>
  Boolean(!product || !isProductActive(product));
